import api from 'service/api'

export const createHousehold = async (userId: any, household: any, communityId: any) => {
  const data = await api.createUserManagementHousehold({
    houseHoldName: household.firstName,
    communityId: communityId,
    userId: userId
  })
  
  return data
}

export const assingHousehold = async (userId: any, household: any, communityId: any) => {
  const data = await api.assingUserManagementHousehold({
    houseHoldId: household.id,
    communityId: communityId,
    userId: userId
  })

  return data
}

export const unassignHousehold = async (userId: any, communityId: any) => {
  const data = await api.unassingUserManagementHousehold(userId, communityId)
  return data
}


const toPayload = (user: any, communityId: any) => {
  return {
    //"id": 0,
    //"guid": "",
    //"userId": 0,
    "communityId": communityId,
    "isMekomeUser": user.population?.isLocalMember,
    "givenName": user.population?.firstName,
    "familyName": user.population?.lastName,
    "middleName": user.population?.middleName,
    "nickName": user.population?.nickName,
    "mainMobilePhone": user.population?.phone === null || user.population?.phone.trim() === "" ?  null : user.population?.phone,
    "email": user.population?.email,
    "gender": user.population?.gender,
    "relationshipsStatus": "",
    "israeliId": user.population?.identityNumber,
    "status": 0,
    "brandID": 0,
    "roleInCommunity": user.population?.roleInCommunity ?? "",
    "maritalStatus": user.population?.maritalStatus,
    "contactPerson1": user.emergency?.contacts.length > 0 ? user.emergency.contacts[0].name : "",
    "contactPerson2": user.emergency?.contacts.length == 2 ? user.emergency.contacts[1].name : "",
    "contactPersonCellPhone1": user.emergency?.contacts.length > 0 ? user.emergency.contacts[0].phone : null,
    "contactPersonCellPhone2": user.emergency?.contacts.length == 2 ? user.emergency.contacts[1].phone : null,
    "shelter": user.population?.shelter ?? "",
    "addressCity": user.population?.city,
    "addressStreet": user.population?.street,
    "addressHouseNumber": user.population?.houseNumber,
    "dateOfBirth": user.population?.birthDate,//?.toISOString().split('.')[0] + 'Z',
    "otherPhone": user.population?.extraPhone,
    "secondaryMobilePhone": user.population?.extraMobile,
    "communityNickName": "",
    "communityStatus": 0
  }
}

export const createUser = async (payload: any, communityId: any) => {
  const modifiedPayload = toPayload(payload, communityId)

  let data = await api.createUserManagementOne(modifiedPayload, communityId);
  return { data }
}

export const editUser = async (payload: any, communityId: any) => {
  const requestPayload = toPayload(payload, communityId)
  let data = await api.updateUserManagementOne(payload.id, requestPayload, communityId)
  return { data }
}
